/**
 * User Session State Manager
 * Handles loggedIn session storage configuration and management for user dashboard states
 */
class UserSessionManager {
	constructor() {
		this.storageKey = "loggedIn";
		this.defaultSessionData = {
			loggedInDashboard: false,
			loggedInInvoice: false,
			loggedInShipment: false,
			loggedInPassbook: false,
		};
	}

	initializeSessionStorage() {
		sessionStorage.setItem(
			this.storageKey,
			JSON.stringify(this.defaultSessionData)
		);
	}

	getSessionData() {
		try {
			const data = sessionStorage.getItem(this.storageKey);
			return data ? JSON.parse(data) : this.defaultSessionData;
		} catch (error) {
			console.error("Error parsing session data:", error);
			return this.defaultSessionData;
		}
	}

	updateSessionProperty(key, value) {
		try {
			const currentData = this.getSessionData();
			const updatedData = {
				...currentData,
				[key]: value,
			};
			sessionStorage.setItem(this.storageKey, JSON.stringify(updatedData));
		} catch (error) {
			console.error("Error updating session property:", error);
		}
	}

	updateMultipleSessionProperties(updates) {
		try {
			const currentData = this.getSessionData();
			const updatedData = {
				...currentData,
				...updates,
			};
			sessionStorage.setItem(this.storageKey, JSON.stringify(updatedData));
		} catch (error) {
			console.error("Error updating multiple session properties:", error);
		}
	}

	resetSessionStorage() {
		this.initializeSessionStorage();
	}

	clearSessionStorage() {
		sessionStorage.removeItem(this.storageKey);
	}

	isLoggedIn(key) {
		const data = this.getSessionData();
		return data[key] === true;
	}
}

const userSessionManager = new UserSessionManager();

export default userSessionManager;
export { UserSessionManager };
